import { GoalsScreen } from "@/apps/goals/types";

export const GOALS_APP_PATH = "/apps/goals";

const GOALS_SCREEN_PATHS: Partial<Record<GoalsScreen, string>> = {
  regionSelector: "region",
  wheel: "wheel",
  activeGoal: "active",
  goalCompleted: "completed",
  goalFailed: "failed",
};

export const getGoalsScreenPath = (screen: GoalsScreen) =>
  GOALS_SCREEN_PATHS[screen];

export const getGoalsScreenUrl = (screen: GoalsScreen) => {
  const path = getGoalsScreenPath(screen);

  return path ? `${GOALS_APP_PATH}/${path}` : GOALS_APP_PATH;
};
